
<div class="kt-section">
	<div class="kt-section__content">
		<div class="modal-header">
			<h4 class="modal-title">
				{{_data.productItem.kod}} - {{_data.productItem.name}} - {{_data.specialCode}}
			</h4>
			<button type="button" class="close" aria-label="Close" (click)="close()">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<div  *ngIf="!(isCheckVariationProduct | async)">
				<kt-custom-description [description]="desc">
				</kt-custom-description>
			</div>

			<div class="row sktLot-2" *ngIf="!(isCheckVariationProduct | async)">
				<div class="col-md-7">
					<div class="form-group row">
						<label class="col-lg-12 col-form-label">{{ 'FE.ORDERS.SPECIALCODEVARIATION.LABELS.VARIATION' | localize }}</label>
						<div class="col-lg-12 kt-margin-b-10-tablet-and-mobile">
							<mat-select class="form-control"
										placeholder="{{ 'FE.ORDERS.SPECIALCODEVARIATION.PLACEHOLDERS.VARIATION' | localize }}"
										[(value)]="selectVariationProduct"
										(selectionChange)="onChangeSpecialVariationProduct()"
										required>
								<mat-option disabled>
									<table class="table table-striped responsive" wt-responsive-table>
										<thead>
											<tr>
												<th width="120">{{ 'FE.ORDERS.SPECIALCODEVARIATION.COMBOBOX.VARIATION.TH1' | localize }}</th>
												<th width="140">{{ 'FE.ORDERS.SPECIALCODEVARIATION.COMBOBOX.VARIATION.TH2' | localize }}</th>
											</tr>
										</thead>
									</table>
								</mat-option>
								<mat-option *ngFor="let subVariation of (subVariationList | async); index as i"
											[value]="subVariation"
											[ngClass]="{'gridBackground': i % 2 == 0}">
									<table class="table table-striped responsive vrt-table" wt-responsive-table>
										<tbody>
											<tr>
												<td width="120">
													{{subVariation.expirationDate ? subVariation.expirationDate : '-'}}
												</td>

												<td width="140">
													{{subVariation.barcode  ? subVariation.barcode : '-'}}
												</td>
											</tr>
										</tbody>
									</table>
								</mat-option>
							</mat-select>
						</div>
					</div>
				</div>
				<div class="col-md-2">
					<div class="form-group row text-center">
						<label class="col-lg-12 col-form-label">{{ 'FE.ORDERS.SPECIALCODEVARIATION.LABELS.STOCK' | localize }}</label>
						<!--stok görme yetkisi var ise burayı göster-->
						<div class="col-lg-12 margin-top-10 kt-margin-b-10-tablet-and-mobile stock" *ngIf="_data.stokView">
							{{selectVariationProduct?.stockQuantity ? selectVariationProduct.stockQuantity : '-'}}

						</div>

						<div class="col-lg-12 margin-top-10 kt-margin-b-10-tablet-and-mobile stock" *ngIf="!_data.stokView">
							-

						</div>
					</div>
				</div>
				<div class="col-md-3">
					<div class="form-group row">
						<label class="col-lg-12 col-form-label">{{ 'FE.ORDERS.SPECIALCODEVARIATION.LABELS.ORDEREDQTY' | localize }}</label>
						<div class="col-lg-12 kt-margin-b-10-tablet-and-mobile">
							<input type="number"
								   class="form-control"
								   [ngStyle]="{'border-color': orderedQty > 0 ? 'blue': ''}"
								   [(ngModel)]="orderedQty"
								   (blur)="onBlurStokControlByOrderedQty()"
								   placeholder="{{ 'FE.ORDERS.SPECIALCODEVARIATION.PLACEHOLDERS.ORDEREDQTY' | localize }}"
								   min="0"
								   oninput="this.value = Math.abs(this.value)" />
						</div>
					</div>
				</div>
			</div>

			<div class="row" *ngIf="(isCheckVariationProduct | async)">
				<div class="col-md-12 text-center text-danger margin-top-10">
					<h5>{{ 'FE.INFOMESSAGE.ORDERS.EXPIRATIONDATELOTMODAL.NOTFOUNDEXPIRATIONORBARCODE' | localize }}</h5>
				</div>
			</div>


		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="close()">{{ 'FE.ORDERS.SPECIALCODEVARIATION.BUTTONS.CLOSE' | localize }}</button>
			<button type="button" class="btn btn-primary" (click)="btnProductSave()" *ngIf="!(isCheckVariationProduct | async)">{{ 'FE.ORDERS.SPECIALCODEVARIATION.BUTTONS.SAVE' | localize }}</button>
		</div>
	</div>
</div>
